__turbopack_context__.v({
  "active": "tooltip-module-scss-module__3zyWAa__active",
  "bottom": "tooltip-module-scss-module__3zyWAa__bottom",
  "left": "tooltip-module-scss-module__3zyWAa__left",
  "right": "tooltip-module-scss-module__3zyWAa__right",
  "top": "tooltip-module-scss-module__3zyWAa__top",
  "ttButton": "tooltip-module-scss-module__3zyWAa__ttButton",
  "ttContent": "tooltip-module-scss-module__3zyWAa__ttContent",
  "ttWrapper": "tooltip-module-scss-module__3zyWAa__ttWrapper",
});
